import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loading = false;

  setLoading(value: boolean){
    Promise.resolve(null).then(() => this.loading = value);
  }

  getLoading(){
    return this.loading;
  }
}
